import { OnDestroy, OnInit, Component } from '@angular/core';
import { ValidatorService } from 'app/shared/services/validator.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { BsModalRef } from 'ngx-bootstrap';
import { Observable, Subject } from 'rxjs';
import { CustomerService } from 'app/views/appviews/quote/customer.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';

@Component({
  selector: 'app-modal-budget-approver',
  styleUrls: ['modal-budget-approver.style.scss'],
  templateUrl: 'modal-budget-approver.template.html'
})
export class ModalBudgetApproverComponent implements OnDestroy, OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private flag = false;
  private errorMessages: any;
  /**Formularios */
  private formApprover: FormGroup;
  /**Retorno a pantalla padre */
  public onClose: Subject<string>;
  /**Catalogos */
  private catalogApprovers: Observable<IDtoCatalog[]>;
  private approver: string;
  private staffTypeName: string;
  private projectCustomerId: number;
  private customerId: number;
  private module: string;
  constructor(private formBuilder: FormBuilder
    , private configGeneral: AppConfig
    , private bsModalRef: BsModalRef
    , private customerService: CustomerService) {
    this.initializeFormApprover();
  }
  ngOnDestroy(): void {
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    if (this.module == 'Commission' || this.module == 'Payroll') {
      this.catalogApprovers = this.customerService.getCatalogPayrollApprovers(this.projectCustomerId);
        this.catalogApprovers.subscribe(x => {
          if(x.length == 0) {
            this.configGeneral.newToast('Validación', 'No existen aprobadores para este presupuesto', 'error');
          }
        });
    } else {
      if (this.staffTypeName == 'Oficina') {
        this.catalogApprovers = this.customerService.getCatalogApprovers(this.customerId);
        this.catalogApprovers.subscribe(x => {
          if(x.length == 0) {
            this.configGeneral.newToast('Validación', 'No existen aprobadores para este presupuesto', 'error');
          }
        });
      } else {
        this.catalogApprovers = this.customerService.getCatalogApproversByProjectCustomer(this.projectCustomerId);
        this.catalogApprovers.subscribe(x => {
          if(x.length == 0) {
            this.configGeneral.newToast('Validación', 'No existen aprobadores para este presupuesto', 'error');
          }
        });
      }
    }
  }
  private initializeFormApprover() {
    this.formApprover = this.formBuilder.group({
      approver: [null, [Validators.required]]
    });
  }
  private submitForm(): void {
    if (this.formApprover.valid) {
      this.update();
    } else {
      this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
    }
  }
  private update(): void {
    //this.approver = this.formApprover.value.approver;
    this.onClose.next(this.approver);
    this.bsModalRef.hide();
  }
  private onCancel(): void {
    this.bsModalRef.hide();
  }
  private changeApprover(dto: IDtoCatalog): void {
    if (dto === undefined) {
        return;
    }
    this.approver = dto.additional;
  }
}